import { combineEpics } from "redux-observable";

import { avatarEpic } from "./avatars";
import { configEpic } from "./config";
import { electronIntergrationEpic } from "./electronIntegration";
import { errorsEpic } from "./errors";
import { idleEpic } from "./idle";
import { loginEpic } from "./login";
import { notificationsEpic } from "./notifications";
import { persistEpic } from "./persist";
import { profileEpic } from "./profile";
import { protoEpic } from "./proto";
import { roomsEpic } from "./rooms";
import roster from "./roster";
import { rosterSearchEpic } from "./rosterSearch";
import { rosterSortEpic } from "./rosterSort";
import { routerEpic } from "./router";
import { sipCallEpic } from "./sipCall";
import { trackingEpic } from "./tracking";
import { typingIndicatorsEpic } from "./typingIndicators";

export const rootEpic = combineEpics(
    avatarEpic,
    configEpic,
    sipCallEpic,
    persistEpic,
    protoEpic,
    roomsEpic,
    idleEpic,
    loginEpic,
    routerEpic,
    typingIndicatorsEpic,
    rosterSearchEpic,
    rosterSortEpic,
    trackingEpic,
    errorsEpic,
    roster,
    notificationsEpic,
    profileEpic,
    electronIntergrationEpic,
);
